import { useContext } from 'react';

import { Box, Typography, useMediaQuery } from '@mui/material';

import CustomImageComponent from '@/components/shared/custom/custom-image';
import FixtureScore from '@/components/shared/fixture-score';
import ApercibidosStatusIcon from '@/components/shared/icons/apercibidos-status-icon';
import { REDUCERS } from '@/constants/reducers';
import { Context } from '@/context';
import { getCountryImage, getMasterPhotoById } from '@/helpers/images-helper';
import { getPlayerIconWhenIsNotOk } from '@/helpers/players-helper';
import { toPriceInEuros } from '@/helpers/prices-helper';

import EquipoAddPlayerBox from './EquipoAddPlayerBox';

const EquipoPlayerLineupFantasyMode = ({ player, onClick, customSize, banquillo = false }) => {
    const { dispatch } = useContext(Context);
    const id = player?.information?.id ?? 0;
    const racha = player?.fantasyPlayer?.information?.fitness ?? player?.fantasyPlayer?.fitness;

    const marketValue =
        player?.fantasyPlayer?.information?.marketValue ?? player?.fantasyPlayer?.marketValue ?? 0;

    const subida = player?.fantasyPlayer?.information?.subida ?? player?.fantasyPlayer?.subida ?? 0;

    const points = player?.fantasyPlayer?.information?.points ?? player?.fantasyPlayer?.points ?? '-';

    const media =
        player?.fantasyPlayer?.information?.averagePoints?.toFixed(2) ??
        player?.fantasyPlayer?.averagePoints?.toFixed(2) ??
        '-';

    const color = '#fff';

    const isMobile = useMediaQuery('(max-width:576px)');
    const cardHeight = isMobile ? 120 : 130;

    let size = isMobile ? 70 : 80;

    if (customSize) {
        size = customSize;
    }

    const handleClick = (playerId) => {
        if (onClick) {
            onClick();
        } else if (playerId > 0) {
            dispatch({ type: REDUCERS.SHOW_MASTER_ACCIONES_PLAYER_ID, payload: playerId });
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: banquillo ? 'auto' : cardHeight,
                width: size,
            }}
        >
            <Box sx={{ position: 'relative', width: size, height: size }} onClick={() => handleClick(id)}>
                <CustomImageComponent
                    src={getMasterPhotoById(id)}
                    alt="jugador"
                    width={size}
                    height={size}
                    onClick={() => handleClick()}
                />

                {player?.generalStatus?.isApercibido && (
                    <ApercibidosStatusIcon
                        iconWidth={15}
                        iconHeight={15}
                        styles={{ position: 'absolute', bottom: 0, left: '8px' }}
                    />
                )}

                <Box style={{ position: 'absolute', bottom: 0, right: '5px' }}>
                    {getPlayerIconWhenIsNotOk(
                        player?.generalStatus?.status,
                        player?.generalStatus?.statusLevel
                    )}
                </Box>

                {player?.convocatoriaSeleccion?.isConvocado && (
                    <Box style={{ position: 'absolute', top: 0, right: 0 }}>
                        <CustomImageComponent
                            src={getCountryImage(player?.convocatoriaSeleccion?.countryCode, 30)}
                            width={20}
                            height={20}
                            alt="selección"
                            style={{ borderRadius: '50%' }}
                        />
                    </Box>
                )}
            </Box>
            {id === 0 && <EquipoAddPlayerBox />}

            {id > 0 && (
                <Box display={'flex'} justifyContent={'center'} gap={'4px'} mt={0.5}>
                    {racha?.map((score, index) => (
                        <FixtureScore
                            key={index}
                            score={score}
                            isAvailable={true}
                            width={15}
                            height={15}
                            pstyles={{ fontSize: '10px' }}
                        />
                    ))}
                </Box>
            )}

            {marketValue > 0 && (
                <Typography
                    sx={{ textAlign: 'center', color: color, fontSize: '12px' }}
                    onClick={() => handleClick(id)}
                >
                    {marketValue > 0 ? toPriceInEuros(marketValue) : id > 0 ? '-' : ''}
                </Typography>
            )}

            {!isNaN(subida) && (
                <Typography
                    sx={{
                        textAlign: 'center',
                        fontSize: '10px',
                        background: subida > 0 ? '#338d42' : '#d65555',
                        color: '#fff',
                        width: '60px',
                        borderRadius: '4px',
                    }}
                    onClick={() => handleClick(id)}
                >
                    {subida !== 0 ? toPriceInEuros(subida) : id > 0 ? '-' : ''}
                </Typography>
            )}

            {id > 0 && points > 0 && (
                <Box display={'flex'} justifyContent={'center'} gap={'4px'}>
                    <Typography fontSize={11} color={color}>
                        P: {points}
                    </Typography>
                    <Typography fontSize={11} color={color}>
                        M: {media}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default EquipoPlayerLineupFantasyMode;
